import axios from 'axios'

import { handleRequestError } from './request'

// import { ERROR_MESSAGE_SAVING } from '../constants'

export const REQUEST_PENSION_CONTRIBUTIONS = 'REQUEST_PENSION_CONTRIBUTIONS'
export const RECEIVE_PENSION_CONTRIBUTIONS = 'RECEIVE_PENSION_CONTRIBUTIONS'
// const SAVE_PENSION_CONTRIBUTION = 'SAVE_PENSION_CONTRIBUTION'

export const requestPensionContributions = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_PENSION_CONTRIBUTIONS, data: { taxReturnId } })

    axios
        .get(`/pensioncontributions?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receivePensionContributions({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receivePensionContributions({ fetchSuccessful: true }))
                return
            }

            dispatch(receivePensionContributions({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receivePensionContributions = (data) => ({ type: RECEIVE_PENSION_CONTRIBUTIONS, data })

// const savePensionContribution = (data) => (dispatch) => {
//     dispatch({ type: SAVE_PENSION_CONTRIBUTION, data })

//     const { id } = data

//     return axios
//         .put(`/pensioncontributions/${id}`, data)
//         .then((response) => {
//             const responseData = response?.data || {}
//             dispatch(
//                 receivePensionContributions({
//                     items: [responseData],
//                 })
//             )
//         })
//         .catch((error) => {
//             dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
//         })
// }

// export const updateAndSavePensionContribution = (data) => (dispatch) => {
//     dispatch(receivePensionContributions({ items: [data] }))
//     dispatch(savePensionContribution(data)).catch(() => {})
// }
